import { render, staticRenderFns } from "./PoiDialog.vue?vue&type=template&id=1b85df0a&scoped=true"
import script from "./PoiDialog.vue?vue&type=script&lang=js"
export * from "./PoiDialog.vue?vue&type=script&lang=js"
import style0 from "./PoiDialog.vue?vue&type=style&index=0&id=1b85df0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b85df0a",
  null
  
)

export default component.exports